import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

export const PageLayout = ({ children, title, paths }) => {
  const Path = ({ paths, title }) => {
    if (!paths) {
      return <span>{title}</span>;
    }

    const PathsElemets = paths.map((path, index) => (
      <span key={index}>
        <Link to={path.link}>{path.title}</Link>
        <span>{" / "}</span>
      </span>
    ));
    return (
      <>
        {PathsElemets}
        <span>{title}</span>
      </>
    );
  };

  return (
    <Container>
      <Row>
        <Col>
          <div className="paths-component mt-2 mb-4">
            <Path paths={paths} title={title} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="page-component p-3 mb-5">{children}</div>
        </Col>
      </Row>
    </Container>
  );
};

PageLayout.propTypes = {
  title: PropTypes.string.isRequired,
  paths: PropTypes.array,
  children: PropTypes.element.isRequired,
};
